import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  ActionBarIcon: {
    marginRight: 20,
  },
}));
